import React from "react";
import { Redirect, Link } from "react-router-dom";
import client from "@culturehq/client";

import { useFetch } from "app/hooks";
import { Trans } from "app/utils";

import Recognition from "./Recognition";

const RecognitionSingular = ({ match }) => {
  const { error, fetching, json: { recognition } } = useFetch(
    () => client.getRecognition({ recognitionId: match.params.recognitionId }),
    [match.params.recognitionId]
  );

  if (error) {
    return <Redirect to="/404" push />;
  }

  if (fetching) {
    return null;
  }

  return (
    <div className="col-xs-12 col-sm-8 col-sm-offset-2 col-lg-6 col-lg-offset-3">
      <Recognition recognition={recognition} />

      <Link className="back" to="/recognitions">
        <Trans>See All Recognitions</Trans>
      </Link>
    </div>
  );
};

export default RecognitionSingular;
